import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { Box, Button, makeStyles } from '@material-ui/core';
import { CloudUpload } from '@material-ui/icons';
import request from '../../../../services/network/request';
import { useAuth } from '../../../../auth/authProvider';
import CampanhasTable from './CampanhasTable/CampanhasTable';
import InserirCampanhaModal from './CampanhasTable/modals/InserirCampanhaModal';
import AdicaoRegrasCampanhas from './CampanhasTable/modals/AdicaoRegrasCampanhas';
import { StatusCampanha } from '../../../../helpers/enums';
import style from './CampanhasTable/CampanhasTable.styles';

const useStyles = makeStyles(style);

const Campanhas = props => {
  const classes = useStyles(props);
  const { token } = useAuth();
  const [tableData, setTableData] = useState([]);
  const [total, setTotal] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [adicaoRegrasCampanhasModal, setAdicaoRegrasCampanhasModal] = useState(false);
  const [regrasCampanhas, setRegrasCampanhas] = useState({
    discountValue: [],
    mwMinValue: '',
    mwMaxValue: '',
    discountAmount: '',
  });
  const [formData, setFormData] = useState({
    nome: '',
    redirecionamento: '',
    imgDesktop: null,
    imgMobile: null,
    dataInicio: '',
    dataFim: '',
    status: StatusCampanha.Inativa,
  });

  const { isFetching: isLoading, refetch } = useQuery(
    ['fetch-campanhas-bs'],
    () => {
      return request.get('backstage/comunidade/campanhas', { token });
    },
    {
      onSuccess: data => {
        setTableData([...data.content]);
        setTotal(data.total);
      },
    },
  );

  return (
    <>
      <Box display="flex" justifyContent="flex-end" mb={2}>
        <Button
          color="primary"
          onClick={() => setIsOpen(prev => !prev)}
          variant="contained"
          startIcon={<CloudUpload />}
        >
          INSERIR CAMPANHA
        </Button>
      </Box>
      <CampanhasTable data={tableData} total={total} refetch={refetch} isLoading={isLoading} />
      <InserirCampanhaModal
        refetch={refetch}
        open={isOpen}
        onClose={() => setIsOpen(false)}
        setFormData={setFormData}
        formData={formData}
        classes={classes}
        setAdicaoRegrasCampanhasModal={setAdicaoRegrasCampanhasModal}
      />
      <AdicaoRegrasCampanhas
        open={adicaoRegrasCampanhasModal}
        onClose={() => setAdicaoRegrasCampanhasModal(false)}
        regrasCampanhas={regrasCampanhas}
        setRegrasCampanhas={setRegrasCampanhas}
        classes={classes}
        setFormData={setFormData}
      />
    </>
  );
};

export { Campanhas };
